import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"ui progress teal\" {{fui-progress (hash percent=this.progress)}} {{this.updateProgress @progress}}>\n  <div class=\"bar\"></div>\n  <div class=\"label\">\n    {{yield}}\n  </div>\n</div>", {
  moduleName: "ui-kit/components/progress/index.hbs"
});